import { loanSellerAdjustmentsApi } from 'app/services/api';

import { LOAN_APPLICATION_ACTION_NAME_PREFIX } from 'constants/loanApplication';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const LOAN_SELLER_ADJUSTMENTS_ACTION_TYPE = createNamedActions(
  // LOAN_APPLICATION_ACTION_NAME_PREFIX is used for Redux Middleware in Loan Editor
  `${LOAN_APPLICATION_ACTION_NAME_PREFIX}/sellerAdjustments`,
  {
    EDIT_SELLER_ADJUSTMENTS: 'EDIT_SELLER_ADJUSTMENTS',
  },
);

export const editLoanSellerAdjustmentsAction = params => async dispatch => {
  const { data } = await loanSellerAdjustmentsApi.editAdjustments(params);

  return dispatch({
    type: LOAN_SELLER_ADJUSTMENTS_ACTION_TYPE.EDIT_SELLER_ADJUSTMENTS,
    payload: data,
  });
};
